import { useState, useEffect } from 'react';
import * as _ from 'lodash';
import { IListItem } from '@nkr/models/index';
import { Checkbox, FormControl, Panel } from 'react-bootstrap';
import { CheckboxColumnsWrapper } from './styles';
import { ISelectedCenterContactPosition } from './models';

interface IProps {
    emailFlagList: IListItem[],
    receiveEmailOption: number,
    centerContactPositionList: ISelectedCenterContactPosition[],
    onReceiveEmailOptionChange: (optionid: number) => void,
    onPositionChange: (positionId: number) => void,
    onCheckAll: () => void
}

const Positions = (props: IProps) => {
    useEffect(() => {
        if (props.centerContactPositionList.filter(x => x.selected).length == 0) {
            setShowUnchecked(true);
        }
    }, [props.centerContactPositionList]);

    const [checkAll, setCheckAll] = useState(false);
    const [showUnchecked, setShowUnchecked] = useState(true);

    const handleCheckAll = () => {
        setCheckAll(!checkAll)
        props.onCheckAll();
    };

    const positionList = _.sortBy(props.centerContactPositionList, item => item.description);
    const filteredList = showUnchecked ? positionList : positionList.filter(x => x.selected);

    const disableCheckAll = props.receiveEmailOption > 0;
    const disableShowUnchecked = filteredList.length == 0 || disableCheckAll;

    return (
        <Panel>
            <Panel.Heading>Positions</Panel.Heading>
            <Panel.Body>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: 5 }}>Email Contacts That:</div>
                        <div>
                            <FormControl
                                componentClass='select'
                                value={props.receiveEmailOption}
                                onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => props.onReceiveEmailOptionChange(parseInt(e.currentTarget.value))}
                            >
                                <option value={0}>- In the Positions Selected Below-</option>
                                {props.emailFlagList.map(flag =>
                                    <option key={'flag-' + flag.id} value={flag.id}>Receive {flag.description} Emails</option>
                                )}
                            </FormControl>
                        </div>
                    </div>
                    <div>
                        <Checkbox inline style={{ marginTop: 0, marginBottom: 0 }} disabled={disableCheckAll} checked={checkAll} onClick={handleCheckAll}>Check All</Checkbox>
                        <Checkbox inline style={{ marginTop: 0, marginBottom: 0 }} disabled={disableShowUnchecked} checked={showUnchecked} onClick={() => setShowUnchecked(!showUnchecked)}>Show Unchecked</Checkbox>
                    </div>
                </div>

                <CheckboxColumnsWrapper className='row'>
                    {filteredList.map(position =>
                        <div key={'position-' + position.id} className='col-xs-12 col-lg-2'>
                            <Checkbox style={{ marginTop: 0, marginBottom: 0, fontSize: 12 }} value={position.id} disabled={props.receiveEmailOption > 0} checked={position.selected} onClick={() => props.onPositionChange(position.id)}>{position.description}</Checkbox>
                        </div>
                    )}
                </CheckboxColumnsWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default Positions;